export class TransportInvoiceDetailModel {
  id: number = 0;
  transportInvoiceId: number = 0;
  documentId: number = 0;
  document: string = '';
  documentType: number = 0;
  consecutive: number = 0;
  dateDocument: string = '';
  transportValuePay: number = 0;
  transportValueInvoiced: number = 0;
}
